module.exports = __webpack_public_path__ + "static/grafika3@2x-681e19797212fd4dec85ef8b06b2e4b3.png";